export default __webpack_public_path__ + "static/media/1-friend-icon.765a5932.svg";